import { DataSourceApprovalStatus } from '../models';

export function isMatchingDataSourceApprovalStatus(
  value: string | undefined,
  enumValue: DataSourceApprovalStatus,
): boolean {
  if (!value) return false;
  return value.toUpperCase() === enumValue.toUpperCase();
}
